import { GetBalanceReportDataLocal, GetTotalReportDataLocal, getBalanceReportLocal } from "../db/report/baoCaoTongHopNgay";
import { FetchChuyenDiLocal, FetchGiuLaiLocal, FetchNhanVeLocal } from "../db/report/localBackend";
import { ReportType } from "../redux/TongHopSlice";
import { isLocalMode } from "../utils/common";
import ApiHelper from "./ApiHelper";

export type RptNhanVeParamsType = {
    selectedReport: ReportType,
    ngay: string,
    mienDaiCuocId: number,
    contactId: number,
    daiIds: string[],
    loaiCuocIds: string[]
}
export const TongHopReport = {
    FetchNhanVe: async (payload: RptNhanVeParamsType) => {
        if (isLocalMode()) {
            return FetchNhanVeLocal(payload)
        } else {
            const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
            const url = encodeURI(`report/getRptNhanVe?ngay=${ngay}&mienDaiCuocId=${mienDaiCuocId}` +
                `&contactId=${contactId}&daiIds=${daiIds}&loaiCuocIds=${loaiCuocIds}`)
            const result = await ApiHelper.get(url)
            return result!.data
        }
    },
    FetchChuyenDi: async (payload: RptNhanVeParamsType) => {
        if (isLocalMode()) {
            return FetchChuyenDiLocal(payload)
        } else {
            const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
            const url = encodeURI(`report/getRptChuyenDi?ngay=${ngay}&mienDaiCuocId=${mienDaiCuocId}` +
                `&contactId=${contactId}&daiIds=${daiIds}&loaiCuocIds=${loaiCuocIds}`)
            const result = await ApiHelper.get(url)
            return result!.data
        }
    },
    FetchGiuLai: async (payload: RptNhanVeParamsType) => {
        if (isLocalMode()) {
            return FetchGiuLaiLocal(payload)
        } else {
            const { contactId, daiIds, ngay, mienDaiCuocId, loaiCuocIds } = payload;
            const url = encodeURI(`report/getRptGiuLai?ngay=${ngay}&mienDaiCuocId=${mienDaiCuocId}` +
                `&contactId=${contactId}&daiIds=${daiIds}&loaiCuocIds=${loaiCuocIds}`)
            const result = await ApiHelper.get(url)
            return result!.data
        }
    },
    FetchLaiLo: async (payload: RptNhanVeParamsType) => {
        if (isLocalMode()) {

            return GetTotalReportDataLocal(payload)
        } else {
            const { contactId, ngay, mienDaiCuocId } = payload;
            const url = encodeURI(`report/getTotalReport?ngay=${ngay}&mienDaiCuocId=${mienDaiCuocId}` +
                `&contactId=${contactId}`)
            const result = await ApiHelper.get(url)
            console.log(result)
            return result!.data
        }
    },
    FetchDongBoTinNhan: async (ngay: string) => {

        const url = encodeURI(`/contact/dongBoTinNhan?ngay=${ngay}`)
        const result = await ApiHelper.get(url)
        return result!.data

    },
}